import { AuthUserTypeEnum } from "@/app/_constant/authType";
import { AuthProfile } from "@r123/auth";

export const getRepostWinTrackerPayload = (originId: string, authProfile?: AuthProfile, isMobile?: boolean): any => {
    return {
        enent_metric: 'Click',
        event_name: 'repost win',
        feature: 'Repost Listing Enquiry',
        feature_listing_class: 'Secondary',
        feature_object_id: originId,
        feature_object_type: 'Listing',
        platform: isMobile ? 'Mobile': 'Desktop',
        source_category: 'Portal',
        source_data: 'Web',
        user_id: authProfile?.uuid || '',
        user_type: authProfile?.user_type === AuthUserTypeEnum.agent
            ? 'agents'
            : 'consumers'
    };
}